module.exports = __webpack_public_path__ + "static/media/unreadIcon.9aaa7ecb.svg";